import cn from 'classnames';

import { firstLetters } from 'libs/string';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import styles from './Testimonials.module.scss';

const baseClass = 'testimonials';

export type Testimonial = {
  quote: string;
  name: string;
  role: string;
};

type Props = {
  title?: string;
  description?: string;
  data: Testimonial[];
  layout?: 'grid' | 'compact' | 'spotlight';
  className?: string;
};

export const Testimonials = ({ title, description, data, layout, className }: Props) => {
  return (
    <section
      className={cn(
        styles[`${baseClass}-wrapper`],
        layout === 'compact' && styles[`${baseClass}-wrapper--compact`],
        layout === 'spotlight' && styles[`${baseClass}-wrapper--spotlight`],
        className,
      )}
    >
      <div className={styles[`${baseClass}-container`]}>
        {(title || description) && <TitleBlock title={title} description={description} />}

        <div className={styles[`${baseClass}-list`]}>
          {data.map((item, index) => (
            <div key={index} className={styles[`${baseClass}-card`]}>
              <p className={styles[`${baseClass}-quote`]}>{`"${item.quote}"`}</p>

              <div className={styles[`${baseClass}-author`]}>
                <span className={styles[`${baseClass}-avatar`]}>{firstLetters(item.name)}</span>

                <div className={styles[`${baseClass}-author-info`]}>
                  <strong className={styles[`${baseClass}-name`]}>{item.name}</strong>
                  <p className={styles[`${baseClass}-role`]}>{item.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
